import { AddressData } from "../types/Address";
import { patientApiUrl } from "./api";

const API_URL = "/Addresses";

export const getData = async (id: number): Promise<AddressData[]> => {
  try {
    const res = await patientApiUrl.get<AddressData[]>(
      `${API_URL}/address?id=${id}`
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all addresses error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const getDataById = async (id: number): Promise<AddressData | null> => {
  try {
    const res = await patientApiUrl.get<AddressData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get address error: ${error.response?.data?.message || error.message}`
    );
    return null; // Return null on error
  }
};

export const createData = async (
  user: Partial<AddressData>
): Promise<AddressData | null> => {
  try {
    const res = await patientApiUrl.post<AddressData>(API_URL, user);
    return res.data;
  } catch (error: any) {
    console.error(
      `Create address error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const updateData = async (
  id: number,
  user: Partial<AddressData>
): Promise<AddressData | null> => {
  try {
    const res = await patientApiUrl.put<AddressData>(`${API_URL}/${id}`, user);
    return res.data;
  } catch (error: any) {
    console.error(
      `Update address error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const deleteData = async (id: number): Promise<boolean> => {
  try {
    await patientApiUrl.delete(`${API_URL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete address error: ${error.response?.data?.message || error.message}`
    );
    return false;
  }
};
